export default "__VITE_ASSET__BovBE5Y8__"